
/**
 * Build a search result table row
 * @param {} $rootScope 
 * @param {} recentSearchesFactory 
 * @returns {} 
 */
export default function (plannerFactory) {

    var searchResultRowTemplate = `
        <td ng-if="!result.hiddenTitle">
           <span>{{ result.classSection }} {{ result.classDesc }}</span>
           <div class="class-note" ng-if="::result.noteText" uib-tooltip="{{ result.noteText }}">
                <i class="fal fa-info-circle"></i>
            </div>
        </td>
        <td ng-if="result.hiddenTitle"></td>
        <td>{{ hideDayTime ? '-' : result.meetingDay }}</td>
        <td ng-bind="result.location"></td>
        <td ng-bind="result.room"></td>
        <td>{{ hideDayTime ? '-' : (result.meetingStartTime|dateTime:\'time\') + \'-\' + (result.meetingEndTime|dateTime:\'time\') }}</td>
        <td>{{result.meetingStartDate|date:"d MMM"}}-{{result.meetingEndDate|date:"d MMM"}}</td>
        <td>
           <button class="btn btn-outline-primary" title="Add {{result.classDesc}} {{result.classNo}} to planner"
               ng-click="addToPlanner()"
               ng-if="!hideDayTime && result.meetingStartTime !== null && !result.hiddenTitle && result.room!==\'PLACEMENT\'" stop-event>
                    <i class="fal fa-plus "></i>
            </button>
           <span class="row-closed" title="{{result.classDesc}} {{result.classNo}} is closed">CLOSED</span>
        </td>`;

    return {
        scope: {
            course: '=',
            result: '='
        },
        restrict: 'A',
        replace: false,
        template: searchResultRowTemplate,
        link: (scope, element) => {

            if (scope.result.enrolmentStatus !== 'O') {
                element[0].classList.add('closed');
            }

            // hide day and time for any item where day, start and end are not defined
            scope.hideDayTime = true;
            if (scope.result.meetingDay && scope.result.meetingStartTime && scope.result.meetingEndTime) {
                scope.hideDayTime = false;
            }

            scope.addToPlanner = () =>
                plannerFactory.addToPlanner(scope.result, scope.course.courseCode, scope.course.description, scope.course.courseId, scope.course.termId);            

        }
    };
};